import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';

import { HeaderAppearanceEvents } from '@unicup-ticketing/core';
import { ButtonComponent } from '@unicup-ticketing/ui';
import { Dispatcher } from '@ngrx/signals/events';
import { rxResource } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RouterLink } from '@angular/router';

export interface DashboardConfig {
  resourceValidDestructor: boolean;
}

@Component({
  selector: 'ticketing-hero-dashboard',
  imports: [ButtonComponent, RouterLink],
  templateUrl: './hero-dashboard.component.html',
  styleUrl: './hero-dashboard.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroDashboardComponent implements OnInit {
  selectedQueue = signal<string | undefined>(undefined);
  private readonly dispatcher = inject(Dispatcher);
  private readonly http = inject(HttpClient);

  showExactDrawLocations = rxResource({
    stream: () => this.http.get<DashboardConfig>(environment.api.configBaseUrl),
  });

  ngOnInit(): void {
    this.dispatcher.dispatch(HeaderAppearanceEvents.requestHero());
  }
}
